import React, { useState, useEffect } from 'react';
import Footer from './Footer';
import MobileFooter from './MobileFooter';

const ResponsiveFooter = ({ activePage }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to determine if the viewport is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // Common breakpoint for mobile
    };

    // Set initial value
    checkMobile();

    // Add listener for window resize
    window.addEventListener('resize', checkMobile);

    // Clean up
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile ? (
    <MobileFooter activePage={activePage} />
  ) : (
    <Footer activePage={activePage} />
  );
};

export default ResponsiveFooter; 